module.exports = __webpack_public_path__ + "img/suspended3.c3cabf4d.svg";